module.exports = __webpack_public_path__ + "static/media/MathewsCompany1195.ccf2b363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/MathewsCompany1195.jpg
// module id = 155
// module chunks = 0